import { render, staticRenderFns } from "./TableSampleRecibo.vue?vue&type=template&id=382e3abc&"
import script from "./TableSampleRecibo.vue?vue&type=script&lang=js&"
export * from "./TableSampleRecibo.vue?vue&type=script&lang=js&"
import style0 from "./TableSampleRecibo.vue?vue&type=style&index=0&id=382e3abc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports